export default __webpack_public_path__ + "static/media/JDK.3604538e.jpg";